import React from 'react';
import * as S from '../ExternalDataTabs.styles';

interface HudleIpAddressesTabProps {
  data: Record<string, any>;
}

export const HudleIpAddressesTab: React.FC<HudleIpAddressesTabProps> = ({ data }) => {
  const ipAddresses = data.ip_addresses || [];

  const formatDate = (dateString?: string) => {
    if (!dateString) return '—';
    try {
      return new Date(dateString).toLocaleString('ru-RU');
    } catch {
      return dateString;
    }
  };

  if (ipAddresses.length === 0) {
    return <S.EmptyState>Нет данных об IP адресах</S.EmptyState>;
  }

  return (
    <div>
      <S.SectionTitle>IP адреса ({ipAddresses.length})</S.SectionTitle>
      {ipAddresses.map((ip: any, index: number) => (
        <S.ListItem key={index}>
          <S.ListItemTitle>{ip.ip_address || 'Неизвестный IP'}</S.ListItemTitle>
          <S.InfoRow>
            <S.InfoLabel>Первое использование</S.InfoLabel>
            <S.InfoValue>{formatDate(ip.first_seen)}</S.InfoValue>
          </S.InfoRow>
          <S.InfoRow>
            <S.InfoLabel>Последнее использование</S.InfoLabel>
            <S.InfoValue>{formatDate(ip.last_seen)}</S.InfoValue>
          </S.InfoRow>
          <S.InfoRow>
            <S.InfoLabel>Количество действий</S.InfoLabel>
            <S.InfoValue>{ip.action_count || 0}</S.InfoValue>
          </S.InfoRow>
          {ip.user_agent && (
            <S.InfoRow>
              <S.InfoLabel>User-Agent</S.InfoLabel>
              <S.InfoValue style={{ fontSize: '11px', wordBreak: 'break-all' }}>
                {ip.user_agent}
              </S.InfoValue>
            </S.InfoRow>
          )}
        </S.ListItem>
      ))}
    </div>
  );
};

